import { render, staticRenderFns } from "./ComponentsForm.vue?vue&type=template&id=41d6770c&scoped=true&"
import script from "./ComponentsForm.vue?vue&type=script&lang=js&"
export * from "./ComponentsForm.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsForm.vue?vue&type=style&index=0&id=41d6770c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d6770c",
  null
  
)

export default component.exports